var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,7.9H7.5c-2.1,0-3.7,1.7-3.7,3.7v21.5v6c0,2.1,1.7,3.7,3.7,3.7h7.6c0.6,0,1.2-0.5,1.2-1.2 c0-0.6-0.5-1.2-1.2-1.2H7.5c-0.8,0-1.4-0.6-1.4-1.4v-6V16.9h39.7v16.2v6c0,0.8-0.6,1.4-1.4,1.4h-7.6c-0.6,0-1.2,0.5-1.2,1.2 c0,0.6,0.5,1.2,1.2,1.2h7.6c2.1,0,3.7-1.7,3.7-3.7v-6V11.6C48.2,9.5,46.5,7.9,44.5,7.9z M6.2,14.6v-3c0-0.8,0.6-1.4,1.4-1.4h36.9 c0.8,0,1.4,0.6,1.4,1.4v3H6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1,32.7l-5.6-9.6c-0.2-0.4-0.6-0.6-1-0.6H20.4c-0.4,0-0.8,0.2-1,0.6l-5.6,9.6c-0.2,0.4-0.2,0.8,0,1.2 l5.6,9.6c0.2,0.4,0.6,0.6,1,0.6h11.1c0.4,0,0.8-0.2,1-0.6l5.6-9.6C38.3,33.6,38.3,33.1,38.1,32.7z M16.2,33.3l4.2-7.3l2.3,4 c-0.8,0.8-1.4,2-1.4,3.3c0,2.6,2.1,4.6,4.6,4.6c0.4,0,0.8-0.1,1.2-0.2l2.3,4h-8.4L16.2,33.3z M26,35.6c-1.3,0-2.3-1-2.3-2.3 c0-1.3,1-2.3,2.3-2.3s2.3,1,2.3,2.3C28.3,34.6,27.3,35.6,26,35.6z M31.6,40.6l-2.3-4c0.8-0.8,1.4-2,1.4-3.3c0-2.6-2.1-4.6-4.6-4.6 c-0.4,0-0.8,0.1-1.2,0.2l-2.3-4h8.4l4.9,8.5L31.6,40.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneral);
export default __webpack_public_path__ + "static/media/icon-general.0418dbc488ed492b0249556b6833c3b7.svg";
export { ForwardRef as ReactComponent };